import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Material } from '@classes/material';
// import { environment } from 'environments/environment';
import { BehaviorSubject, Observable, of } from 'rxjs';
import { map } from 'rxjs/operators';
import * as _moment from 'moment';
import { EnvConfigurationService } from './env-configuration.service';
const moment = _moment;

@Injectable({
  providedIn: 'root'
})
export class MaterialService {
  environment = this.envConfigurationService.environment;

  private basePath = this.environment.apiUrl + '/material';

  public materials = new BehaviorSubject<Array<Material>>([]);

  lastUpdate: _moment.Moment;

  constructor(
    private http: HttpClient,
    public envConfigurationService: EnvConfigurationService
  ) { }

  getMaterials(forceRefresh?: boolean): Observable<Array<Material>> {
    if (this.materials.value.length && this.lastUpdate.isBefore(moment().add(this.environment.refreshListSecond, 'second')) && !forceRefresh) {
      return of(this.materials.value);
    }
    return this.http.get<Array<Material>>(this.basePath).pipe(
      map(m => {
        this.materials.next(m);
        this.lastUpdate = moment();
        return m;
      })
    );
  }

  createOrUpdateMaterial(material?: Material): Observable<Material> {
    if (material?.id) {
      //update
      const url = `${this.basePath}/${material?.id}`;
      return this.http.patch<any>(url,
        material).pipe(map(m => {
          return m
        }));
    } else {
      //create
      return this.http.post<any>(this.basePath,
        material
      ).pipe(map(m => {
        return m
      }));
    }
  }
  deleteMaterial(materialId: string): Observable<any> {
    const baseUrl = this.basePath;
    const url = `${baseUrl}/${materialId}`;
    return this.http.delete(url);
  }
}
